<script setup lang="ts">
import {Button} from "../Library";

const {totalActiveFilters, mobileOnly = true} = defineProps<{
    totalActiveFilters: number;
    mobileOnly?: boolean;
}>();

const model = defineModel();
</script>
<template>
    <div class="pointer-events-none fixed bottom-0 left-0 z-10 mx-auto mt-auto flex w-full justify-center pb-4">
        <div class="flex w-full items-end justify-between px-3 px-4 xl:ml-64 xl:max-w-full">
            <div class="pointer-events-auto">
                <Button
                    class="w-full rounded-md bg-askr-green px-8 py-2 text-center font-bold text-white shadow-xl shadow-stone-600 dark:shadow-black"
                    :class="{'2xl:hidden': mobileOnly}"
                    :icon="{
                        icon: 'hugeicons:filter',
                        width: '24',
                    }"
                    @click="model = !model"
                >
                    {{ totalActiveFilters ? totalActiveFilters : null }}
                </Button>
            </div>
            <slot></slot>
        </div>
    </div>
</template>
<style scoped></style>
